import request from '../utils/request';
import { UserReportTypes } from '../utils/types';

export const reportUserAPI = async (
    eventId: string,
    userId: string,
    type: UserReportTypes
) => {
    await request.post(`/user-reports/${eventId}/${userId}`, {
        type,
    });
};

export const fetchUserReportsAPI = async (userId: string) => {
    const response = await request.get(`/user-reports/${userId}`);

    return response.data;
};
